// util helper methods go here... 

export const utilMethods = {
  
  customLog: (message) => {
    if (process.env.REACT_APP_DEBUG === 'dev') {
        console.log(message);
    }
  },

  getWindowDimensions: () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  },

}